module.exports = __webpack_public_path__ + "static/media/box-m.caa5922c.png";